import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import withStyles from '@mui/styles/withStyles'

import AcquiringChargeFilter from 'components/core/Acquiring/AcquiringCharges/components/AcquiringCharges-filter'
import { Context } from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesContext'
import AcquiringChargeStepper from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesStepper'
import AcquiringChargeTable from 'components/core/Acquiring/AcquiringCharges/components/AcquiringChargesTable'
import { ErrorAlert } from 'components/core/Alert'
import { RootState } from 'redux/store'
import { themeStyles } from 'themes'
import combineStyles from 'utils/combineStyles'

const AcquiringDashboard = () => {
    const { t } = useTranslation()
    const { cardAcquiringCharges, loader } = useSelector((state: RootState) => state.acquiring)

    const [chargesInputs, setChargesInputs] = useState<ChargesInputs>({ from: null, to: null, status: null, skip: null, take: null })

    const contextValues = { chargesInputs, setChargesInputs, loader, charges: cardAcquiringCharges }

    return (
        <Context.Provider value={contextValues}>
            <h3>{t('Acquiring.Charges')}</h3>
            <ErrorAlert />
            <AcquiringChargeFilter />
            <AcquiringChargeTable />
            <AcquiringChargeStepper />
        </Context.Provider>
    )
}

export default withStyles(combineStyles(themeStyles.useAcquiringStyles, themeStyles.useTableStyles))(AcquiringDashboard)
